import MarginNote from "components/margin-note";
import * as React from 'react';
export default {
  MarginNote,
  React
};